// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"fca19fd2","847":"dec2d2ac"}[chunkId] + ".chunk.css";
};